const ITEM_TOASTS = {
    ITEM_ADDED: "Item succesfully added!",
    ITEM_NOT_ADDED: "Failed to add item",
    ITEM_DELETED: "Item deleted succesfully!",
    ITEM_NOT_DELETED: "Item deletion unsuccesful",
    ITEM_EDITED: "Succesfully item edited!",
    ITEM_NOT_EDITED: "Failed to edit item",
    ITEMS_FETCHED: "Items fetched succesfully",
    ITEMS_NOT_FETCHED: "Failed to fetche items",
    ITEMS_DELETED: "Selected items deleted succesfully",
    ITEMS_NOT_DELETED: "Failed to delete selected items"
}
export default ITEM_TOASTS